import React from "react";
import { useSearchParams, Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const orderId = params.get("order");
  return (
    <div className="cs-cream min-h-[75vh] py-20" data-testid="page-payment-cancel">
      <div className="max-w-2xl mx-auto px-6">
        <div className="cs-eyebrow text-neutral-500">Paiement Stripe</div>
        <h1 className="cs-h1 mt-3 text-4xl lg:text-5xl">Paiement annulé</h1>
        <div className="mt-8 cs-card p-6">
          <div className="flex items-start gap-3">
            <XCircle size={20} className="text-neutral-500 mt-0.5" />
            <div className="text-sm">
              <p>Aucun débit n'a été effectué. Votre commande reste en attente de paiement — vous pouvez relancer la procédure à tout moment depuis votre espace.</p>
            </div>
          </div>
        </div>
        <div className="mt-8 flex gap-3">
          {orderId ? (
            <Link to={`/espace/commande/${orderId}`} className="cs-btn-primary" data-testid="cancel-retry">
              Reprendre le paiement
            </Link>
          ) : (
            <Link to="/espace" className="cs-btn-primary">Retour à mon espace</Link>
          )}
          <Link to="/aide-choix" className="cs-btn-ghost !text-black !border-black">
            Parler au conseiller
          </Link>
        </div>
      </div>
    </div>
  );
}
